import React from 'react';
import { i18n } from 'utils/i18n';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import LoyaltyTermsConditionsModal from 'components/modals/LoyaltyTermsConditionModal';

/**
 * LoyaltyTermsConditionsLink Description
 * fetches and displays the alamo insider terms and conditions
 *
 * @param {object} props - React Props
 * @param {string} props.loyaltyTerms - the T&C text that will be displayed
 * @param {function} props.getLoyaltyTerms - service call to fetch the text
 * @param {function} props.handleOpenModal - launches the modal
 * @return {JSX}
 */

const LoyaltyTermsConditionsLink = ({ loyaltyTerms, getLoyaltyTerms, handleOpenModal }) => {
  const handleClick = (e) => {
    // prevents label click from firing
    e.preventDefault();
    !loyaltyTerms && getLoyaltyTerms();
    handleOpenModal && handleOpenModal();
  };

  return (
    <>
      <Button className='enrollment__terms-conditions-button' onClick={handleClick} linkText>
        {i18n('alamo_insider_terms_conditions')}
      </Button>
      <LoyaltyTermsConditionsModal />
    </>
  );
};

LoyaltyTermsConditionsLink.propTypes = {
  loyaltyTerms: PropTypes.string,
  getLoyaltyTerms: PropTypes.func,
  handleOpenModal: PropTypes.func,
};

export default LoyaltyTermsConditionsLink;
